import { useState } from 'react';
import '../styles.css';

export default function StatistiquesPage() {
  const [scope, setScope] = useState('moi');
  const [period, setPeriod] = useState('12m');

  const statsMoi = [
    { label: 'CA généré', value: '52k€', delta: '↑ +8k vs préc.', up: true, accent: '#95C11F' },
    { label: 'CA reçu', value: '38k€', delta: '↑ +5k vs préc.', up: true, accent: '#3C2618' },
    { label: 'Merci donnés', value: '12', delta: '= stable', up: null, accent: '#95C11F' },
    { label: 'Merci reçus', value: '8', delta: '↑ +2 ce mois', up: true, accent: '#95C11F' },
    { label: 'Tête-à-tête réalisés', value: '24', delta: '↑ +5 ce mois', up: true, accent: '#3C2618' },
    { label: 'Tête-à-Tête à faire', value: '14', delta: 'membres restants', up: null, accent: '#3C2618' },
  ];

  const statsGroupe = [
    { label: 'CA total réseau', value: '284k€', delta: '↑ +31k ce mois', up: true, accent: '#95C11F' },
    { label: 'Membres actifs', value: '38', delta: '↑ +3 ce mois', up: true, accent: '#3C2618' },
    { label: 'Merci transmis', value: '124', delta: '↑ +18 ce mois', up: true, accent: '#95C11F' },
    { label: 'Participation', value: '87%', delta: '↓ -2% vs préc.', up: false, accent: '#3C2618' },
  ];

  const bars = [
    { label: 'Sep', g: 35, r: 25 }, { label: 'Oct', g: 45, r: 30 },
    { label: 'Nov', g: 30, r: 28 }, { label: 'Déc', g: 25, r: 20 },
    { label: 'Jan', g: 60, r: 40 }, { label: 'Fév', g: 50, r: 38 },
    { label: 'Mar', g: 75, r: 55 },
  ];

  const ranking = [
    { initials: 'TM', name: 'Thomas Moreau', ca: '67k€', pct: 100, color: '#95C11F', medal: '🥇' },
    { initials: 'ML', name: 'Marie Laurent', ca: '52k€', pct: 78, color: '#3C2618', medal: '🥈' },
    { initials: 'PB', name: 'Pierre Bernard', ca: '38k€', pct: 57, color: '#7a9e18', medal: '🥉' },
    { initials: 'SC', name: 'Sophie Caron', ca: '21k€', pct: 31, color: '#2563eb', medal: '4' },
  ];

  const presence = [
    { month: 'Sep', present: true }, { month: 'Oct', present: true },
    { month: 'Nov', present: false }, { month: 'Déc', present: true },
    { month: 'Jan', present: true }, { month: 'Fév', present: true },
  ];

  return (
    <div style={{ minHeight: '100vh' }}>
      <div style={{ padding: '12px 20px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1c1c1e' }}>Statistiques</h1>
        <div style={{ display: 'flex', background: '#e5e5ea', borderRadius: 10, padding: 2 }}>
          {['6m','12m'].map(p => (
            <button key={p} onClick={() => setPeriod(p)}
              style={{ padding: '5px 12px', borderRadius: 8, border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer', background: period === p ? 'white' : 'transparent', color: period === p ? '#1c1c1e' : '#8e8e93' }}>
              {p === '6m' ? '6 mois' : '12 mois'}
            </button>
          ))}
        </div>
      </div>

      <div className="mb-content" style={{ paddingTop: 0 }}>
        {/* Toggle scope */}
        <div style={{ display: 'flex', background: '#e5e5ea', borderRadius: 10, padding: 2, marginBottom: 14 }}>
          {[['moi','Mes stats'],['groupe','Mon groupe']].map(([key, label]) => (
            <button key={key} onClick={() => setScope(key)}
              style={{ flex: 1, padding: '6px', borderRadius: 8, border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer', background: scope === key ? 'white' : 'transparent', color: scope === key ? '#1c1c1e' : '#8e8e93', boxShadow: scope === key ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}>
              {label}
            </button>
          ))}
        </div>

        {/* KPIs */}
        <div className="mb-stat-grid mb-mb-md">
          {(scope === 'moi' ? statsMoi : statsGroupe).map(s => (
            <div key={s.label} className="mb-stat-card">
              <div className="mb-stat-accent" style={{ background: s.accent }} />
              <div className="mb-stat-label">{s.label}</div>
              <div className="mb-stat-value" style={{ fontSize: s.value.length > 5 ? 20 : 26 }}>{s.value}</div>
              <div className={`mb-stat-delta ${s.up === true ? 'up' : s.up === false ? 'down' : 'neutral'}`}>{s.delta}</div>
            </div>
          ))}
        </div>

        {/* Graphique barres */}
        <div className="mb-card mb-mb-md">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <span style={{ fontSize: 14, fontWeight: 600, color: '#1c1c1e' }}>
              {scope === 'moi' ? 'CA mensuel (€)' : 'CA groupe mensuel (€)'}
            </span>
            {scope === 'moi' && (
              <div style={{ display: 'flex', gap: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#95C11F' }} />
                  <span style={{ fontSize: 10, color: '#8e8e93' }}>Généré</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#3C2618' }} />
                  <span style={{ fontSize: 10, color: '#8e8e93' }}>Reçu</span>
                </div>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 100 }}>
            {bars.map(b => (
              <div key={b.label} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                <div style={{ display: 'flex', gap: 2, alignItems: 'flex-end', height: 80 }}>
                  <div style={{ width: scope === 'moi' ? 12 : 22, borderRadius: '4px 4px 0 0', background: b.g > 60 ? '#95C11F' : '#c5df7a', height: `${b.g}%`, minHeight: 4 }} />
                  {scope === 'moi' && <div style={{ width: 12, borderRadius: '4px 4px 0 0', background: b.r > 45 ? '#3C2618' : '#8b5e3c', height: `${b.r}%`, minHeight: 4 }} />}
                </div>
                <span style={{ fontSize: 9, color: '#8e8e93' }}>{b.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Donut / Classement */}
        {scope === 'moi' ? (
          <div className="mb-card mb-mb-md">
            <div className="mb-card-title">Répartition de mon activité</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <svg width="90" height="90" viewBox="0 0 90 90" style={{ flexShrink: 0 }}>
                <circle cx="45" cy="45" r="35" fill="none" stroke="#f2f2f7" strokeWidth="14"/>
                <circle cx="45" cy="45" r="35" fill="none" stroke="#95C11F" strokeWidth="14" strokeDasharray="88 132" strokeDashoffset="0" transform="rotate(-90 45 45)"/>
                <circle cx="45" cy="45" r="35" fill="none" stroke="#3C2618" strokeWidth="14" strokeDasharray="66 154" strokeDashoffset="-88" transform="rotate(-90 45 45)"/>
                <circle cx="45" cy="45" r="35" fill="none" stroke="#c5df7a" strokeWidth="14" strokeDasharray="46 174" strokeDashoffset="-154" transform="rotate(-90 45 45)"/>
                <text x="45" y="49" textAnchor="middle" fontSize="12" fontWeight="700" fill="#1c1c1e">12</text>
              </svg>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[
                  { label: 'Merci donnés', pct: '40%', color: '#95C11F' },
                  { label: 'Tête-à-tête', pct: '30%', color: '#3C2618' },
                  { label: 'Recos données', pct: '21%', color: '#c5df7a' },
                  { label: 'Invitations', pct: '9%', color: '#f2f2f7' },
                ].map(d => (
                  <div key={d.label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 10, height: 10, borderRadius: '50%', background: d.color, flexShrink: 0 }} />
                    <span style={{ fontSize: 12, color: '#3c3c43', flex: 1 }}>{d.label}</span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: '#1c1c1e' }}>{d.pct}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="mb-card mb-mb-md">
            <div className="mb-card-title">Top membres — CA généré</div>
            {ranking.map((r, i) => (
              <div key={r.name} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', borderBottom: i < ranking.length-1 ? '0.5px solid #f2f2f7' : 'none' }}>
                <span style={{ width: 20, textAlign: 'center', fontSize: 13, fontWeight: 700 }}>{r.medal}</span>
                <div style={{ width: 32, height: 32, borderRadius: '50%', background: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: 'white', flexShrink: 0 }}>{r.initials}</div>
                <span style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#1c1c1e' }}>{r.name}</span>
                <div style={{ width: 80, height: 6, background: '#f2f2f7', borderRadius: 3, overflow: 'hidden' }}>
                  <div style={{ height: '100%', background: '#95C11F', borderRadius: 3, width: `${r.pct}%` }} />
                </div>
                <span style={{ fontSize: 12, fontWeight: 600, color: '#95C11F', width: 40, textAlign: 'right' }}>{r.ca}</span>
              </div>
            ))}
          </div>
        )}

        {/* Présence */}
        <div className="mb-card mb-mb-md">
          <div className="mb-card-title">Présence aux réunions</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6,1fr)', gap: 6 }}>
            {presence.map(p => (
              <div key={p.month} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                <div style={{ width: 34, height: 34, borderRadius: '50%', background: p.present ? '#f0f8e1' : '#fce4ec', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: p.present ? '#3B6D11' : '#e1306c' }}>
                  {p.present ? '✓' : '✗'}
                </div>
                <span style={{ fontSize: 9, color: '#8e8e93' }}>{p.month}</span>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
            <span style={{ fontSize: 12, color: '#8e8e93' }}>29/33 réunions</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#95C11F' }}>87% de présence</span>
          </div>
        </div>
      </div>
    </div>
  );
}
